module.exports = __webpack_public_path__ + "static/media/VOLLAVILLA.5965acc8.jpg";